import { Controller } from '@hotwired/stimulus'

export default class NestedFormController extends Controller {
  static targets = ['links', 'template', 'appendForm', 'addButton']

  connect() {
    this.wrapperClass = this.element.dataset.wrapperClass || 'nested-fields'
  }

  add_association(event) {
    this.disableMainPostLocation()
    if (event?.isTrusted) {
      event.preventDefault()
      const quillElement = this.templateTarget.content.querySelector(
        '[data-controller="quill"]'
      )
      delete quillElement.dataset.value
      quillElement.innerHTML = '<p></p>'
      quillElement.classList.add('nested-ele')
      let content = this.templateTarget.innerHTML.replaceAll(
        'NEW_RECORD',
        Date.now()
      )

      const wrapper = document.createElement("div")
      wrapper.innerHTML = content

      const selectedOptions = Array.from(
        this.element.querySelectorAll(".dropdown.share-post-options:first-child .form-check-input:checked")
      ).map(cb => cb.dataset.option)

      const checkboxes = wrapper.querySelectorAll(".dropdown.share-post-options .form-check-input")

      checkboxes.forEach(cb => {
        cb.checked = selectedOptions.includes(cb.dataset.option)
      })

      const selectedReplyOptions = Array.from(
        this.element.querySelectorAll(".reply-opt-select .form-check-input:checked")
      ).map(cb => cb.value)

      const replyCheckboxes = wrapper.querySelectorAll(".reply-opt-select .form-check-input")

      replyCheckboxes.forEach(cb => {
        cb.checked = selectedReplyOptions.includes(cb.value)
      })

      const display = wrapper.querySelector(".selected-value-display")
      if (display) {
        display.textContent = Array.from(replyCheckboxes)
          .filter(cb => cb.checked)
          .map(cb => cb.nextElementSibling.textContent.trim())
          .join(", ") || "Select Reply Options"
      }

      const shareTypesSpan = wrapper.querySelector(".share_types")
      if (shareTypesSpan) {
        shareTypesSpan.textContent = Array.from(checkboxes)
          .filter(cb => cb.checked)
          .map(cb => cb.nextElementSibling.textContent.trim())
          .join(", ") || "Select Share Options"
      }

      this.appendFormTarget.append(...wrapper.childNodes)
      const modal = document.querySelector("#addPostModal .modal-body");
      modal.scrollTo({
        top: modal.scrollHeight,
        behavior: 'smooth'
      });
    } else {
      const time = Date.now()
      const quillElement = this.templateTarget.content.querySelector(
        '[data-controller="quill"]'
      )
      const extra = event.target.dataset.extras
      quillElement.dataset.value = extra
      quillElement.innerHTML = `<p>${extra}</p>`
      quillElement.classList.add('nested-ele')
      let content = this.templateTarget.innerHTML.replaceAll('NEW_RECORD', time)
      this.appendFormTarget.insertAdjacentHTML('beforeend', content)
      const progressCircle = document.getElementById('progressCircle' + time)
      const inputLength = Math.min(extra.length - 1, 280)
      const maxChars = 280
      const progressPercentage = (inputLength / maxChars) * 100

      const dashOffset = 100 - progressPercentage
      try {
        setTimeout(() => {
          progressCircle.style.strokeDashoffset = dashOffset
        }, 100)
      } catch { }
    }
    let forms = document?.querySelectorAll("[data-controller='emoji']")
    if (forms.length == 6) {
      $('.add_child_post').remove()
    }
  }

  remove_association(event) {
    event.preventDefault()
    const wrapper = event.target.closest(`.${this.wrapperClass}`)
    const wrapperDOM = this.wrapperClass === 'post-form-wrapper' ? wrapper.querySelector('.nested-fields') : wrapper

    // Was this form's post_media visible?
    const postMedia = wrapper.querySelector('.post_media')
    const wasVisible = postMedia && !postMedia.classList.contains('d-none')
    const currentTarget = event.target.closest('.post-form-wrapper')
    const mediaElement = currentTarget.previousElementSibling?.querySelector('.post_media');

    if (wrapperDOM.dataset.newRecord === 'true') {
      wrapper.remove()
    } else {
      wrapper.querySelector("input[name*='_destroy']").value = 1
      wrapper.style.display = 'none'
      wrapper.querySelector("input[type='text']").value = ''
    }

    // Check whether any child forms are still visible
    const visibleChildForms = this.getVisibleOptionFieldsCount()

    // If no child forms remain, enable and show the main post media options
    if (visibleChildForms === 0) {
      this.enableMainPostLocation()
    } else if (wasVisible) {
      if (mediaElement) {
        mediaElement.classList.remove('d-none')
      } else {
        this.element.closest('form')?.querySelector('.post_media')?.classList.remove('d-none')
      }
    }

    this.toggleAddButton()
  }

  addOption(event) {
    event.preventDefault()
    const content = this.templateTarget.innerHTML.replaceAll(
      'NEW_RECORD',
      Date.now()
    )
    const optionsCount = this.getVisibleOptionFieldsCount()
    if (optionsCount < 4) {
      this.appendFormTarget.insertAdjacentHTML('beforeend', content)
      this.toggleAddButton()
    }
  }

  getVisibleOptionFieldsCount() {
    return Array.from(
      this.appendFormTarget.querySelectorAll('.nested-fields')
    ).filter((element) => element.offsetParent !== null).length
  }

  toggleAddButton() {
    if (!this.hasAddButtonTarget) return

    const optionsCount = this.getVisibleOptionFieldsCount()
    if (optionsCount >= 4) {
      this.addButtonTarget.classList.add('d-none')
    } else {
      this.addButtonTarget.classList.remove('d-none')
    }
  }

  disableMainPostLocation() {
    const mainPostForm = this.element.querySelector('.main-post-form')
    if (!mainPostForm) return

    const mainPostMedia = mainPostForm.querySelector('.post_media')
    const locationButton = mainPostMedia?.querySelector(
      '[data-action*="strip-post#openLocationModal"]'
    )

    mainPostMedia?.classList.add('d-none')
    locationButton?.classList.add('disabled')
  }

  enableMainPostLocation() {
    const mainPostForm = this.element.querySelector('.main-post-form')
    if (!mainPostForm) return

    const mainPostMedia = mainPostForm.querySelector('.post_media')
    const locationButton = mainPostMedia?.querySelector(
      '[data-action*="strip-post#openLocationModal"]'
    )

    mainPostMedia?.classList.remove('d-none')
    locationButton?.classList.remove('disabled')
  }
}
